/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// Swatch tooltip on hover and tap
document.querySelectorAll('.swatch__button').forEach(function(button) {
  var label = button.querySelector('.swatch__label');
  var input = button.querySelector('.swatch__input');
  if (!label) return;

  var tooltip = document.createElement('span');
  tooltip.className = 'swatch-tooltip';
  tooltip.textContent = label.getAttribute('data-tooltip');
  button.style.position = 'relative';
  button.appendChild(tooltip);

  // Desktop hover
  label.addEventListener('mouseenter', function() {
    tooltip.classList.add('swatch-tooltip--visible');
  });
  label.addEventListener('mouseleave', function() {
    tooltip.classList.remove('swatch-tooltip--visible');
  });

  // Mobile tap
  if (input) {
    input.addEventListener('change', function() {
      document.querySelectorAll('.swatch-tooltip').forEach(function(t) {
        t.classList.remove('swatch-tooltip--visible');
      });
      if (input.checked) {
        tooltip.classList.add('swatch-tooltip--visible');
      }
    });
  }
});





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
